import { PosMarketConnectionState, PosMarketOpenMode, PosMarketplaceAvailability, PosMarketplaceUnlockReason, PosMarketStatus } from "../enums";

export interface PosMarketCatalogItemDto {
  code: string;
  name: string;
  logoUrl: string | null;
  description: string | null;
  status: PosMarketStatus;
  connectUrl?: string | null;
  openMode?: PosMarketOpenMode;
}

export interface PosMarketCatalogDto {
  code: string | null;
  name: string;
  logoUrl: string | null;
  description: string | null;
  status: PosMarketStatus;
  connectUrl?: string | null;
  openMode?: PosMarketOpenMode;
  apps: PosMarketCatalogItemDto[];
}

export interface PosMarketConnectedCatalogItemDto {
  code: string;
  name: string;
  logoUrl: string | null;
  description: string | null;
  /** Name of the catalog the item belongs to */
  catalogName?: string | null;
  /** Absolute URL of the catalog's icon */
  catalogLogoUrl?: string | null;
  /** True for an app of its catalog (a Clover app), false for the catalog's single item (a LinkToAny integration) */
  isApp?: boolean;
  /** The Clover dashboard for a connected app; the Clover authorization link for a pending one */
  url: string;
  openMode: PosMarketOpenMode;
  /** Pending while the account has started connecting and not finished */
  status?: PosMarketConnectionState;
  /** UTC timestamp of when the account's integration was connected */
  connectedOn?: string | null;
  canDisconnect?: boolean;
}

export interface PosMarketplaceUnlockDto {
  reason: PosMarketplaceUnlockReason;
  canUpgradePlan: boolean;
}

export interface PosMarketplaceAvailabilityDto {
  status: PosMarketplaceAvailability;
  unlock?: PosMarketplaceUnlockDto | null;
}
